import { CacheStrategy, DataSourceStrategy } from '@rammetec/data-access';
import { MODULE_CONFIG } from '../types/moduleConfig.js';
export const moduleConfigDescriptor = {
    name: MODULE_CONFIG,
    label: 'Module Config',
    domain: 'vectorhub',
    collectionPath: 'org/{orgId}/vh_agents/{agentId}/moduleConfigs',
    pathPatternKeys: { orgId: 'string', agentId: 'string' },
    version: 1,
    description: 'Per-agent module configuration. Written by VH console; server pushes to agent on connect/change.',
    repositoryConfig: {
        dataSource: DataSourceStrategy.Firestore,
        cache: CacheStrategy.InMemory,
    },
    fields: [
        {
            name: 'moduleId',
            label: 'Module ID',
            type: 'string',
            required: true,
            maxLength: 80,
            description: '== doc id; agent-runtime module id.',
        },
        {
            name: 'config',
            label: 'Config',
            type: 'object',
            required: true,
            description: 'Free JSON; the module defines its schema.',
        },
        {
            name: 'updatedAt',
            label: 'Updated At',
            type: 'string',
            required: true,
            maxLength: 32,
        },
        {
            name: 'updatedBy',
            label: 'Updated By',
            type: 'string',
            required: true,
            maxLength: 128,
        },
    ],
};
//# sourceMappingURL=moduleConfig.descriptor.js.map